import apiCall from "@/repository";

class PaymentsService {
  baseUrl = "/v1/payments";

  getPayments = (filters = {}, page = 1, pagelen = 20) => {
    const offset = page === 1 ? 0 : pagelen * (page - 1);
    const params = {
      pagelen,
      offset,
      ...filters
    };

    return apiCall.get(`${this.baseUrl}`, { params });
  };

  getPaymentsById = id => {
    return apiCall.get(`${this.baseUrl}/${id}`);
  };

  refund = id => {
    return apiCall.post(`${this.baseUrl}/${id}/refund`);
  };
}

export default new PaymentsService();



// WEBPACK FOOTER //
// ./src/services/payments.js